module.exports = __webpack_public_path__ + "media/assets/images/blog/customerize_7182-5b8f20f9580c5a2f9e25e0978eb51be5.jpg";